import React from "react";

type Option = { label: string; value: string };
type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  icon?: React.ReactNode;
  options: Option[];
  className?: string;
  disabled?: boolean;
};

export default function SelectField({
  value, onChange, placeholder, icon, options, className = "", disabled,
}: Props) {
  return (
    <div
      className={[
        "relative",
        "w-full",
        "rounded-2xl border border-slate-200 bg-white shadow-sm",
        "focus-within:border-slate-300 focus-within:shadow-md",
        className,
      ].join(" ")}
    >
      {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">{icon}</div>}
      <select
        disabled={disabled}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={[
          "appearance-none w-full bg-transparent outline-none",
          icon ? "pl-10" : "pl-4",
          "pr-8 py-[14px] rounded-2xl text-[15px]",
        ].join(" ")}
      >
        <option value="">{placeholder}</option>
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <svg className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" width="18" height="18" viewBox="0 0 24 24">
        <path fill="currentColor" d="M7 10l5 5l5-5z" />
      </svg>
    </div>
  );
}